import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { useBeneficiarySettings } from './hooks/useBeneficiarySettings';
import { TcsmStates } from '../../../../root/tcsm-model';
import { BeneficiarySettings } from './model/epi-props';
import BeneficiaryUpdateForm from './beneficiary-update-form';
import { GetMappedRelationship } from './create-beneficiary/helper/create-beneficiary-helper';
import { convertBeneficiaryDataToPageViewModel, getBeneficiaryUpdatePageOptionsByType } from './helper/beneficiary-helper';
import { BeneficiaryData, BeneficiaryRelationshipData } from './model/beneficiary-models';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';

interface Props {
	settingsId: string;
}
export function BeneficiaryUpdate(props: Props) {

	const { settingsId } = props;

	const { plan } = useParams<any>();
	const loaded = useBeneficiarySettings(settingsId);
	const settings = useSelector<TcsmStates, BeneficiarySettings>(state => state?.epiProps?.beneficiarySettingsState?.epiContent);	
	const beneficiaryData = useSelector<TcsmStates, BeneficiaryData>(state => state?.beneficiariesState?.beneficiaries);
	const beneficiaryRelationships = useSelector<TcsmStates, BeneficiaryRelationshipData[]>(state => state?.beneficiariesState?.relationships);

	const dataForType = plan && beneficiaryData ? beneficiaryData[plan] : null;
	const beneficiaryUpdatePageOptions = getBeneficiaryUpdatePageOptionsByType(plan, settings, beneficiaryData?.default_spouse);

	const beneficiaryUpdatePageModel = convertBeneficiaryDataToPageViewModel(plan, dataForType, beneficiaryRelationships, beneficiaryData?.default_spouse, beneficiaryUpdatePageOptions);	
	const mappedRelationship = GetMappedRelationship(settings?.relationshipCodesMapping);

	if (!loaded) {
		return <LoadingCircle />;
	}

	if (!dataForType || !beneficiaryUpdatePageModel || !beneficiaryUpdatePageOptions){
		return (
			<ContentSpacer>
                    <strong>Not supported</strong>
            </ContentSpacer>			
		);	
	}

	return (
		<BeneficiaryUpdateForm beneficiarySettings={settings} beneficiaryUpdatePageModel={beneficiaryUpdatePageModel}
			mappedRelationship={mappedRelationship} plan={plan} beneficiaryUpdatePageOptions={beneficiaryUpdatePageOptions}  />
	);
}